import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import ErrorMessage from '../components/ErrorMessage';
import Spinner from '../components/Spinner';
import useFetch from '../helpers/useFetch';

const AccountRedirectPage = () => {
  const navigate = useNavigate();
  const fetch = useFetch();
  const { accountId } = useParams();
  const [error, setError] = useState();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}`)
      .then(({ account }) => {
        if (account.domains && account.domains.length > 0) {
          navigate(`/accounts/${accountId}/domains/${account.domains[0].id}/analytics`, { replace: true });
        } else {
          navigate(`/accounts/${accountId}/domains/new`, { replace: true });
        }
      })
      .catch(setError);
  }, [accountId, fetch, navigate]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  return <Spinner />;
};

export default AccountRedirectPage;
